import './styles'
import React from 'react'
import ReactDOM from 'react-dom'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'

import RedBox from 'redbox-react'

// ENTRY POINT into the dashboard application

// both are reassigned exclusively by acceptConfigureStoreReplacement
let reassignableStore
let enhancedHistory

// reassigned exclusively by acceptNProgressReplacement
let unsubscribeNProgressObserver

function getRootNode() {
  return document.getElementById('root')
}

function renderApp(Component, node, store, history) {
  setTimeout(() => {
    ReactDOM.render(<Component history={history} store={store} />, node)
  })
}

function renderErrorOverlay(node, error) {
  ReactDOM.render(<RedBox error={error} />, node)
}

function render(Component, node, store, history) {
  setTimeout(() => {
    if (module.hot) {
      try {
        renderApp(Component, node, store, history)
      } catch (error) {
        renderErrorOverlay(node, error)
      }
    } else {
      renderApp(Component, node, store, history)
    }
  })
}

function acceptNProgressReplacement(observeStoreForNProgress) {
  if (unsubscribeNProgressObserver) {
    unsubscribeNProgressObserver()
  }
  unsubscribeNProgressObserver = observeStoreForNProgress(reassignableStore)
}

function acceptRootContainerReplacement(RootContainer) {
  render(RootContainer, getRootNode(), reassignableStore, enhancedHistory)
}

function acceptConfigureStoreReplacement(configureStore) {
  if (enhancedHistory) {
    enhancedHistory.unsubscribe()
  }

  const storeOptions = {
    syncStateWithLocalStorage: false,
  }

  // TODO ensure that the old store can no longer dispatch
  // so nothing can affect the old store
  // also kill the old store getState so it throws
  // the old sagas will still run on the old dispatch : (

  const previousState = reassignableStore ? reassignableStore.getState() : {}
  reassignableStore = configureStore(previousState, storeOptions)
  enhancedHistory = syncHistoryWithStore(browserHistory, reassignableStore)

  acceptNProgressReplacement(require('./nprogress').default)

  ReactDOM.unmountComponentAtNode(getRootNode())
  setTimeout(() => {
    acceptRootContainerReplacement(require('./components/Root').default)
  }, 100)
  // acceptRootContainerReplacement(require('./components/Root').default)
}

// hot reloading
if (module.hot) {
  // hot reloading for root container and all of its dependencies.
  // effectively covers all used components and their dependencies.
  module.hot.accept('./components/Root', () => {
    acceptRootContainerReplacement(require('./components/Root').default)
  })
  // hot reloading for store configuration function
  // and all of its dependencies.
  // effectively covers all reducers and sagas and their dependencies.
  module.hot.accept('./configureStore', () => {
    acceptConfigureStoreReplacement(require('./configureStore').default)
  })
  // hot reloading for nprogress store observer is not
  // covered by the other hot reload accepts.
  module.hot.accept('./nprogress', () => {
    acceptNProgressReplacement(require('./nprogress').default)
  })
}

// initialize once for the first time
acceptConfigureStoreReplacement(require('./configureStore').default)



// WEBPACK FOOTER //
// ./src/index.js